export const footerlinks = {
    menuItems: [
        {
            title: "Tools",
            links: [
                {
                    text: "Testnet Leaderboard",
                    url: "https://leaderboard.assetchain.org/"
                },
                {
                    text: "Advanced Explorer",
                    url: "https://scan-testnet.assetchain.org/"
                },
                {
                    text: "Bridge",
                    url: "https://bridge-testnet.assetchain.org/"
                },
                {
                    text: "Swap",
                    url: "https://swap-testnet.assetchain.org"
                },
                {
                    text: "Faucet",
                    url: "https://faucet.assetchain.org/"
                }
            ]
        },
        {
            title: "Staking",
            links: [
                {
                    text: "Native Staking",
                    url: "https://testnet-stake.assetchain.org/"
                },
                {
                    text: "Validator Staking",
                    url: "/staking"
                }
            ]
        }
    ]
};
